<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
        <path
            d="M0 0 C0.91579834 0.45004395 0.91579834 0.45004395 1.85009766 0.90917969 C12.418635 6.18433531 20.77327837 12.56453639 29 21 C30.23169922 22.21816406 30.23169922 22.21816406 31.48828125 23.4609375 C48.2842816 40.92413648 56.62379521 64.66598524 56.5 88.625 C56.49033203 90.59569458 56.49033203 90.59569458 56.48046875 92.60620117 C56.06478838 114.8738159 48.33596793 134.94982128 34 152 C33.30261719 152.85980469 32.60523438 153.71960938 31.88671875 154.60546875 C16.93328926 172.23794045 -4.37059299 183.11401729 -27 187 C-54.53404893 188.58871353 -81.47993957 185.16446006 -103.09375 166.359375 C-106.13161798 163.64315812 -109.06426782 160.82590623 -112 158 C-112.65871094 157.41605469 -113.31742188 156.83210937 -113.99609375 156.23046875 C-129.4050153 142.17383131 -138.62659823 118.53346141 -140.22265625 98.1574707 C-141.35458423 69.69094569 -133.97957478 44.06878551 -114.625 22.6875 C-85.54534213 -8.21753719 -38.73846518 -19.34443204 0 0 Z "
            fill="#FF9D00"
            transform="translate(142,11)"
        />
        <path
            d="M0 0 C18.98298411 -0.4984591 35.33524573 6.2994262 49.10546875 19.31640625 C57.77775962 28.52340484 62.68172873 39.00689348 65.8203125 51.15625 C65.9961084 51.79369141 66.1719043 52.43113281 66.35302734 53.08789062 C69.94164535 68.97230637 65.15836738 84.92851862 56.94824219 98.43457031 C54.07331562 102.82287813 50.56569511 106.51101131 46.8203125 110.15625 C45.93666016 111.08824219 45.93666016 111.08824219 45.03515625 112.0390625 C32.89741516 123.9367164 16.82970772 127.59940913 0.45288086 127.59228516 C-17.57278965 127.28536477 -31.56118706 119.90264065 -44.1796875 107.15625 C-57.55540388 92.75578115 -60.82326691 76.7651614 -60.4921875 57.78125 C-59.86931926 42.12649486 -51.9373581 28.26745907 -41.1796875 17.15625 C-37.67175799 14.21570712 -34.02457984 11.63511627 -30.1796875 9.15625 C-29.57511719 8.74761719 -28.97054687 8.33898438 -28.34765625 7.91796875 C-19.82902485 2.54978011 -9.89554428 0.48626753 0 0 Z "
            fill="#FDFDFC"
            transform="translate(97.1796875,36.84375)"
        />
        <path
            d="M0 0 C23.43 0 46.86 0 71 0 C71 2.31 71 4.62 71 7 C47.57 7 24.14 7 0 7 C0 4.69 0 2.38 0 0 Z "
            fill="#3B3738"
            transform="translate(65,126)"
        />
        <path
            d="M0 0 C23.43 0 46.86 0 71 0 C71 2.31 71 4.62 71 7 C47.57 7 24.14 7 0 7 C0 4.69 0 2.38 0 0 Z "
            fill="#393536"
            transform="translate(65,89)"
        />
        <path
            d="M0 0 C23.43 0 46.86 0 71 0 C71 1.98 71 3.96 71 6 C47.57 6 24.14 6 0 6 C0 4.02 0 2.04 0 0 Z "
            fill="#252122"
            transform="translate(65,114)"
        />
        <path
            d="M0 0 C23.43 0 46.86 0 71 0 C71 1.98 71 3.96 71 6 C47.57 6 24.14 6 0 6 C0 4.02 0 2.04 0 0 Z "
            fill="#262223"
            transform="translate(65,102)"
        />
        <path
            d="M0 0 C17.49 0 34.98 0 53 0 C53 2.31 53 4.62 53 7 C35.51 7 18.02 7 0 7 C0 4.69 0 2.38 0 0 Z "
            fill="#3C3839"
            transform="translate(65,77)"
        />
        <path
            d="M0 0 C10.23 0 20.46 0 31 0 C31 1.98 31 3.96 31 6 C20.77 6 10.54 6 0 6 C0 4.02 0 2.04 0 0 Z "
            fill="#272324"
            transform="translate(65,65)"
        />
    </svg>
</template>
